import { Alert, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { fmtCents } from './shared/formatCents';
import { ROUTE_TRANSACTIONS } from '../../../../../../constants/routes';

export function UncategorizedTransactionsBanner({
  count,
  totalCents,
}: {
  count: number;
  totalCents: number;
}) {
  const navigate = useNavigate();

  if (count === 0) return null;

  return (
    <Alert
      type="warning"
      showIcon
      message={`${count} transactions totaling ${fmtCents(totalCents)} need categorization`}
      description="Until categorized, these will appear as 'Uncategorized' in your reports."
      action={
        <Button
          size="small"
          onClick={() => navigate(`${ROUTE_TRANSACTIONS}?uncategorized=true`)}
        >
          Review transactions
        </Button>
      }
      style={{ marginBottom: 16 }}
    />
  );
}
